$(document).ready(function(){   
    if(!$('.moduleMap').length) {
        return;
    }
    
    var objects_href = $('.map').data('objects-href'); 
    $.getJSON(objects_href)
        .done(function(json){

            var mapElement = $('.map').get(0);
            var map = new google.maps.Map(mapElement, {
                zoom:           14,
                center:         new google.maps.LatLng(45.43804440488145, 12.335911889225773),
                scrollwheel:    false
                //draggable:      false
            });

            var markers = [];

            var prevInfoWindow = null;

            var bounds = new google.maps.LatLngBounds();            
            $.each(json.objects, function(n, object) {                                
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(object.location_lat, object.location_lng),
                    title:    object.title,
                    map:      map,
                    rec:      object
                });         
                               
                marker.addListener('click', function() {                    
                    if(prevInfoWindow) {
                        prevInfoWindow.close();
                    }
                    
                    var infowindow = new google.maps.InfoWindow({
                        content: marker.rec.popup_html,
                        maxWidth: 350
                    });                    
                    infowindow.open(map, marker);    
                    prevInfoWindow = infowindow;
                });                    

                bounds.extend(marker.getPosition());
                            
                markers[object.id] = marker;
            });

            
            map.fitBounds(bounds);
            
            var MaxZooomOnStart = 14;
            var listener = google.maps.event.addListener(map, "idle", function() { 
                if(map.getZoom() > MaxZooomOnStart) map.setZoom(MaxZooomOnStart); 
                google.maps.event.removeListener(listener); 
            });

            
            
                        
                        
            $('.moduleMap .filter li').click(function(event){
                event.preventDefault();
                
                $('.moduleMap .filter li').removeClass("selected");
                $(this).addClass("selected");
                                
                var typeId = $(this).data('id')

                markers.forEach(function(m){
                    m.setVisible(m.rec.type_id == typeId);                    
                });        
            });            
        });    
});